import $ from 'jquery'
import Swiper from 'swiper/bundle'

// $('.event-md-sm').on('click', function () {
//   $('body').toggleClass('event-active')
// })
//
// $('.event-btn-close').on('click', function () {
//   $('body').removeClass('event-active')
// })

// $(document).on('click', function (e) {
//   if (
//     $(e.target).closest('.date__wrapper').length === 0 &&
//     $(e.target).closest('.event-md-sm').length === 0 &&
//     $(e.target).closest('.content__wrapper').length === 0
//   ) {
//     $('body').removeClass('event-active')
//   }
// })

const button = $('.home-expand')

const defaultHeight = 170
const text = $('.home-content .vn-excerpt-wrapper')
if (text.length) {
  const textHeight = text[0].scrollHeight
  text.css({ 'max-height': defaultHeight, overflow: 'hidden' })

  if (textHeight <= 100) {
    button.hide()
  }

  button.on('click', function () {
    let newHeight = 0
    if (button.hasClass('active')) {
      newHeight = defaultHeight
      button.removeClass('active')
    } else {
      newHeight = textHeight
      button.addClass('active')
    }
    text.animate(
      {
        'max-height': newHeight,
      },
      250
    )
  })
}

var eventSlider = new Swiper('.hero-events__slider', {
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    nextEl: document.querySelector('.buttons__wrapper .arrow-next'),
    prevEl: document.querySelector('.buttons__wrapper .arrow-prev'),
  },
  pagination: {
    el: '.hero-events-pag',
    clickable: true,
  },
  autoplay: {
    delay: 4000,
    loop: true,
  },
})

var modalEventSlider = new Swiper('.hero-events-modal__slider', {
  slidesPerView: 1,
  autoplay: {
    delay: 4000,
    loop: true,
  },
})

eventSlider.controller.control = modalEventSlider;
modalEventSlider.controller.control = eventSlider;

const $block = $('.home-video')

const el = $block.find('.youtube-video-iframe')
const overlayEl = $block.find('.img-wrapper')
const ytId = el.attr('data-id')

overlayEl.on('click', function () {
  overlayEl.remove()
  el.replaceWith(
    `<iframe src="https://www.youtube-nocookie.com/embed/${ytId}?autoplay=1" allow="autoplay">`
  )
})
